export class Constants {
  public static readonly API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  public static readonly LOGIN_REDIRECT_URL = process.env.REACT_APP_LOGIN_REDIRECT_URL;
}
